import { useAuth } from "../../../Hooks/Auth/useAuth";
import { Button, IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from 'react-router-dom';
import BackgroundCarousel from "../../../layout/BackgroundCarousel";

const InsightsLogin = () => {
  const { showPassword, setShowPassword, loginData, handleChange, error, handleLogin, loader } = useAuth()
  return (
    <>
      <BackgroundCarousel />
      <form onSubmit={handleLogin} className="login-form">
        <h3 className="login-text ">Login</h3>
        <div className="input-set my-2 mx-0">
          <label>Employee Code/E-mail</label>
          <input
            className="mx-0 w100"
            value={loginData?.user_loginname}
            onChange={handleChange}
            name="user_loginname"
            placeholder="Enter Email"
          />
          <p className='text-danger text-left mx-2'>{error?.user_loginname}</p>
        </div>
        <div className="input-set my-2 mx-0">
          <label>Password</label>
          <div className="position-relative">
            <input
              value={loginData?.pmo_criteria}
              onChange={handleChange}
              type={showPassword ? "text" : "password"}
              className="w100"
              name="pmo_criteria"
              placeholder="Enter Password"
            />
            <IconButton
              style={{ position: "absolute", right: "10px", top: "5px" }}
              aria-label="toggle password visibility"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <FontAwesomeIcon icon="fa-solid fa-eye-slash" />
              ) : (
                <FontAwesomeIcon icon="fa-solid fa-eye" />
              )}
            </IconButton>
          </div>
        </div>
        <p className='text-danger text-left'>{error?.pmo_criteria}</p>
        <div className="d-flex justify-content-end text-right">
          <Link to="/sign-up" state={{ key: 'is_forgot' }} className="text-black" style={{ textDecoration: "underline", cursor: 'pointer' }}>Forgot Password?</Link>
        </div>
        {
          loader ?
            <Button
              variant="contained"
              className="login-button mt-1"
            >
              <div className="spinner-border" role="status" style={{ width: "20px", height: "20px" }}>
                <span className="sr-only"></span>
              </div>
            </Button> : <Button
              type="submit"
              variant="contained"
              className="login-button mt-1"
            >
              Login <FontAwesomeIcon icon="fa-solid fa-arrow-right btn-icon" />
            </Button>
        }
        {error.apiError && (
          <p style={{ fontSize: "small", color: "red", textAlign: "center", clear: 'both', paddingTop: '20px !important' }}>
            {error?.apiError}
          </p>
        )}
      </form>
    </>
  );
};

export default InsightsLogin;
